[
  {
    "id": "SR-B8P-PYJAMA-V01",
    "module": "SpellingRegel",
    "difficulty": 302,
    "difficultyTier": 14,
    "levelCode": "B8+",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_moeilijk",
    "familyId": "SR-WEETWOORD-PYJAMA",
    "conceptId": "tricky_y_j_combination",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["pyjama", "pijama", "pyama", "pijame"],
    "correctAnswer": 0,
    "explanation": "'Pyjama' schrijf je met een 'y' én een 'j'. Onthoud: py-ja-ma. De 'y' en 'j' staan naast elkaar.",
    "distractorExplanations": {
      "1": "Het is 'py', niet 'pi'. De 'y' is essentieel.",
      "2": "De 'j' ontbreekt. Het is py-ja-ma, niet py-a-ma.",
      "3": "Het begint met 'py' (niet 'pi') en eindigt op '-ma' (niet '-me')."
    }
  },
  {
    "id": "SR-B8P-MAYONAISE-V01",
    "module": "SpellingRegel",
    "difficulty": 302,
    "difficultyTier": 14,
    "levelCode": "B8+",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_frans",
    "familyId": "SR-WEETWOORD-MAYONAISE",
    "conceptId": "french_loanword_spelling",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["mayonaise", "mayonaisse", "maionaire", "mayonase"],
    "correctAnswer": 0,
    "explanation": "'Mayonaise' schrijf je met een 'y' en '-aise'. Onthoud: mayo-naise. De 'ai' klinkt als 'è'.",
    "distractorExplanations": {
      "1": "Geen dubbele 's'. Het is '-aise', niet '-aisse'.",
      "2": "De 'y' en 'on' ontbreken. Het is ma-yo-naise.",
      "3": "De 'i' ontbreekt. Het is '-aise', niet '-ase'."
    }
  },
  {
    "id": "SR-B8P-ABONNEMENT-V01",
    "module": "SpellingRegel",
    "difficulty": 302,
    "difficultyTier": 14,
    "levelCode": "B8+",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_moeilijk",
    "familyId": "SR-WEETWOORD-ABONNEMENT",
    "conceptId": "tricky_double_consonants",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["abonnement", "abbonement", "abonement", "abbonnement"],
    "correctAnswer": 0,
    "explanation": "'Abonnement' heeft één 'b' en een dubbele 'n'. Onthoud: a-bon-ne-ment. De dubbele letter is de 'n', niet de 'b'.",
    "distractorExplanations": {
      "1": "De 'b' is enkel, niet dubbel. En de 'n' ontbreekt een keer.",
      "2": "Hier ontbreekt een 'n'. Het is abon-ne-ment met dubbele 'n'.",
      "3": "De 'b' is enkel, niet dubbel. Het is a-bon-ne-ment."
    }
  },
  {
    "id": "SR-B8P-ONMIDDELLIJK-V01",
    "module": "SpellingRegel",
    "difficulty": 302,
    "difficultyTier": 14,
    "levelCode": "B8+",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_moeilijk",
    "familyId": "SR-WEETWOORD-ONMIDDELLIJK",
    "conceptId": "tricky_double_consonants",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["onmiddellijk", "onmidelijk", "onmiddelijk", "onmidellijk"],
    "correctAnswer": 0,
    "explanation": "'Onmiddellijk' heeft dubbele 'd' én dubbele 'l'. Onthoud: on-middel-lijk. Het woord 'middel' zit erin.",
    "distractorExplanations": {
      "1": "Hier ontbreken een 'd' en een 'l'. Beide zijn dubbel.",
      "2": "Hier ontbreekt een 'l'. Het is on-middel-lijk met dubbele 'l'.",
      "3": "Hier ontbreekt een 'd'. Het is on-middel-lijk met dubbele 'd'."
    }
  },
  {
    "id": "SR-B8P-PER-SE-V01",
    "module": "SpellingRegel",
    "difficulty": 302,
    "difficultyTier": 14,
    "levelCode": "B8+",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_moeilijk",
    "familyId": "SR-WEETWOORD-PER-SE",
    "conceptId": "latin_loanword_two_words",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["per se", "persé", "persee", "perse"],
    "correctAnswer": 0,
    "explanation": "'Per se' zijn twee woorden. Geen accent nodig in de nieuwe spelling. Het is Latijn en betekent 'per definitie'.",
    "distractorExplanations": {
      "1": "Het accent is niet meer nodig. En het zijn twee woorden.",
      "2": "Geen dubbele 'e'. Het zijn twee losse woorden.",
      "3": "Het zijn twee woorden, niet één."
    }
  }
]